import React, { useCallback, useMemo } from 'react'
import { PaymentFormattedLI } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import './ChoosePayment.scss'

interface IChoosePayment {
  changeSystem: (system: string) => void
  systemList?: PaymentFormattedLI[]
  cryptoList?: PaymentFormattedLI[]
  isLoading: boolean
}

const b = block('choose-payment')

export const ChoosePayment: React.FC<IChoosePayment> = ({
  changeSystem,
  systemList = [],
  cryptoList = [],
  isLoading,
}) => {
  const onChangePaymentSystem = useCallback(
    (value: string) => {
      changeSystem(value)
    },
    [changeSystem],
  )

  const allSystems = useMemo(
    () =>
      [...systemList, ...cryptoList],
    [systemList, cryptoList],
  )

  const allMethods = useMemo(
    () =>
      allSystems?.map(system => (
        <div
          key={system.name + system.slug}
          className={b('method', { slug: system.slug })}
          onClick={() => onChangePaymentSystem(system.slug)}>
          {system.icon && (
            <>
              <img
                src={system.icon}
                alt=''
                className={b('method-icon', { type: system.name.toLowerCase() })}
              />
            </>
          )}

          <div className={b('method-name')}>
            {system.name}
          </div>
        </div>
      )),
    [allSystems, onChangePaymentSystem],
  )

  return (
    <div className={b()}>
      <div className={b('all-methods', {
        triangle: Boolean(!cryptoList.length) && systemList.length >= 3,
        crypto: Boolean(cryptoList.length)
      })}>
        {!isLoading && allMethods}
        {isLoading && (
          <div className={b('method', { hide: !isLoading, loading: isLoading })}>
            <div className={b('spinner')} />
          </div>
        )}
      </div>
    </div>
  )
}
